import Button from '../UI/Button/Button';
import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useAppDispatch } from '../../core/store/hooks';
import { removeUserAsync } from '../../core/store/user/user.thunks';
import { useNavigate } from 'react-router-dom';
import { HOME } from '../../core/router/paths';

interface Props
{
  close: () => void;
}

function DeleteWarningDialog(props: Props)
{
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();

  async function handleConfirmDelete()
  {
    props.close();

    appDispatch(removeUserAsync())
      .then(() => navigate(HOME));
  }

  return (
    <Dialog
      maxWidth='md'
      PaperProps={{ sx: { p: '15px', textAlign: 'center' }}}
      open={true}
      onClose={props.close}>
      <DialogTitle sx={{ fontSize: '30px' }}>Delete account</DialogTitle>
      <DialogContent>
        <Typography variant='body2' sx={{ paddingBottom: '24px' }}>
          Your data will be lost.<br/>Are you sure you want to delete your account?
        </Typography>
        <Button
          id='ConfirmDelete'
          onClick={handleConfirmDelete}
          label='Ok'/>
        <Box style={{ display: 'inline', paddingLeft: '14px' }} />
      </DialogContent>
    </Dialog>);
}

export default DeleteWarningDialog;